import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  Modal,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  User,
} from "@heroui/react";
import OperatorHeader from "./OperatorHeader";
import {
  DashboardIcon,
  // UsersIcon,
  MatchesIcon,
  MarketsIcon,
  ResultIcon,
  BetIcon,
  BetsIcon,
  // OperatorIcon,
  PasswordIcon,
  // Metric
} from "../../../components/admin/DashboardIcons.jsx";
import { logLogout } from "../../../utils/activityLogger";
import SidebarNavItems from "../SidebarNavItems";

const navigation = [
  { name: "Dashboard", href: "/operator/dashboard", icon: <DashboardIcon /> },
//  { name: "Metric", href: "/admin/metric", icon: <Metric /> },
  // { name: "Users", href: "/admin/users", icon: <UsersIcon /> },
  { name: "Markets", href: "/operator/markets", icon: <MatchesIcon /> },
  { name: "Matches", href: "/operator/matches", icon: <MarketsIcon /> },
  // { name: "Operators", href: "/admin/operators", icon: <OperatorIcon /> },
  { name: "Results", href: "/operator/results", icon: <ResultIcon /> },
  { name: "Bets", href: "/operator/bets", icon: <BetIcon /> },
  { name: "Bets History", href: "/operator/betsHistory", icon: <BetIcon /> },
  { name: "Bet Insights", href: "/operator/betsInsights", icon: <BetsIcon /> },
  { name: "Reports", href: "/operator/reports", icon: <BetsIcon /> },
   { name: "Change Password", href: "/operator/changePassword", icon: <PasswordIcon /> },
];

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const flushItem = async () => {
    await logLogout();
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="h-screen flex overflow-hidden bg-gray-100">
      {/* Sidebar for mobile */}
      <Modal isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}>
        <div className="fixed inset-0 flex z-40 md:hidden">
          <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          <div className="relative flex-1 flex flex-col max-w-xs w-full bg-admin_black items-center">
            <div className="absolute top-0 right-0 -mr-12 pt-2">
              <button
                type="button"
                className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                onClick={() => setSidebarOpen(false)}
              >
                <span className="text-white text-xl">×</span>
              </button>
            </div>
            <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
              <div className="flex-shrink-0 flex items-center px-4">
                <div>
                  <img
                    className="h-8 w-auto"
                    src="/img/matka-g.svg"
                    alt="Matka"
                  />
                </div>
              </div>
              <nav className="mt-5 px-2 space-y-1">
                <SidebarNavItems
                  items={navigation}
                  isMobile
                  onNavigate={() => setSidebarOpen(false)}
                />
              </nav>
            </div>
          </div>
        </div>
      </Modal>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col  w-72">
          <div className="flex flex-col h-0 flex-1 border-r border-gray-200 bg-admin_black rounded-lg m-0.5">
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <a href="/operator/dashboard">
                <div className="flex items-center px-4 gap-1 border-b border-white pb-3 pt-1">
                  <div>
                    <img
                      className="items-center"
                      src="/img/matka-g.svg"
                      width={120}
                      alt="Matka"
                    />
                  </div>
                </div>
              </a>

              <nav className="mt-3 flex-1 px-2 space-y-1  bg-admin_black">
                <SidebarNavItems items={navigation} />
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <div className="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 flex items-center justify-between pr-4">
          <div className="flex items-center">
            <button
              type="button"
              className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="text-xl">☰</span>
            </button>
            <span className="text-lg font-semibold text-gray-800">Matka</span>
          </div>

          <div className="flex items-center">
            <Dropdown placement="bottom-end">
              <DropdownTrigger>
                <User
                  as="button"
                  avatarProps={{
                    isBordered: true,
                    src: "https://i.pravatar.cc/150?u=a042581f4e29026024d",
                  }}
                  className="transition-transform"
                  description={localStorage.getItem("email") || ""}
                  name={localStorage.getItem("name") || ""}
                />
              </DropdownTrigger>
              <DropdownMenu aria-label="User Actions" variant="flat">
                <DropdownItem
                  key="logout"
                  color="danger"
                  className="bg-admin_black text-white text-center"
                  onClick={() => flushItem()}
                >
                  Log Out
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none">
          <OperatorHeader />
          <div className="py-6">
            <div className="px-1 md:px-0 lg:px-1 xl:px-2 mx-auto max-w-screen-xl md:max-w-screen-2xl 2xl:max-w-screen-2xl lg:py-4">
              {/* Header */}

              {/* Header */}
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
